import React from 'react';
import DownloadTrayIcon from "../basic/DownloadTrayIcon";
import DownloadManagerModal from "../basic/DownloadManagerModal";

const Header = ({ setShowDownloadModal, showDownloadModal, isDownloadModalNeeded = false }) => {
    return (
        <>
            <div
                className="flex items-center justify-between border border-gray-400 h-[5vh] px-4"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '5vh', border: '1px solid grey', padding: '0 1rem' }}
            >
                <h1 style={{ fontSize: '24px', margin: 0 }}>Privmail</h1>

                {isDownloadModalNeeded && (
                    <div>
                        <DownloadTrayIcon onClick={() => setShowDownloadModal(true)} />
                        <DownloadManagerModal
                            visible={showDownloadModal}
                            onClose={() => setShowDownloadModal(false)}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default Header;
